<script setup>
// Informational modal shown after adding a LIMITED-CAPACITY session to My Schedule
// during the window where My Schedule is live but Save a Seat isn't open yet.
// Opened imperatively via useModal().open(SeatReminderModal, { session }).
const props = defineProps({
    session: { type: Object, required: true },
});
const open = defineModel('open', { default: true });
const emit = defineEmits(['close']);

const title = computed(() => props.session?.title || 'This session');
</script>

<template>
    <FragmentsModalShell
        v-model:open="open"
        :headline="`“${title}” has been added to My Schedule, but you’ll need to save a seat later.`"
        headline-class="tracking-normal"
        @close="emit('close')"
    >
        <!-- White info box: alert icon + explanatory copy -->
        <div class="flex items-start gap-[12px] w-full text-left bg-white rounded-[10px] p-[20px]">
            <svg class="shrink-0 mt-[2.5px] size-[16px] text-(--magenta)" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <circle cx="8" cy="8" r="8" fill="currentColor" />
                <path d="M8 4V9" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                <circle cx="8" cy="11.6" r="0.9" fill="white" />
            </svg>
            <p class="font-hubspot-sans font-light text-[14px] leading-[1.5] text-(--magenta) m-0">
                This is a limited capacity session and requires a saved seat to attend. Seat saving
                opens for VIP pass holders on August 25 at 11:00 AM ET and for general admission pass
                holders on September 1 at 11:00 AM ET.
            </p>
        </div>

        <template #actions>
            <button
                type="button"
                class="rounded-full border border-(--magenta) text-(--magenta) px-[28px] py-[10px]
                    font-hubspot-serif text-[15px] leading-none cursor-pointer transition-colors duration-200
                    hover:bg-(--magenta) hover:text-white
                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--magenta)"
                @click="open = false"
            >Close</button>
        </template>
    </FragmentsModalShell>
</template>
